<div class="content" *ngIf="isLoggedIn">
  <caremoni-header (logoutHandler)="logout()"></caremoni-header>
  <div class="shell-body">
    <caremoni-sidebar class="shell-sidebar" [class.expanded]="sidebarExpanded" (toggleSidebar)="handleToggleSidebar($event)" [isExpanded]="sidebarExpanded" [data]="sidebarData" (handleActiveMenu)="getActiveMenu($event)"></caremoni-sidebar>
    <div class="shell-main">
      <caremoni-sub-header (onExpandBody)="toggleFullScreen()" [menuIcon]="menuIcon" [title]="title"></caremoni-sub-header>
      <div #fullScreenElement class="component-container">
      <ng-content select="router-outlet"></ng-content>
      </div>
    </div>
  </div>
</div>
